.phone-integration-card {
    padding: 16px;
    display: flex;
    gap: 12px;
    align-items: start;
}
